// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__i5x4h","content":"Consent_content__DzJ0Y","footer":"Consent_footer__2jYLP"};